import { compact, isEmpty } from 'lodash'
import { useFormikContext } from 'formik'

import Settings from 'components/TipConfigurations/TipConfigurations'
import TipOptions from 'components/TipConfigurations/TipOptions'
import DefaultTipOption from 'components/TipConfigurations/DefaultTipOption'
import RevenueCentersOverrideList from 'components/VenueSettings/Drawers/TipConfigurations/RevenueCentersOverrideList'

const TipConfigurationsBody = ({ showValidationErrors }) => {
  const { values, setFieldValue, errors } = useFormikContext()

  const { custom_tip_option, tip_values, selected_tip_option } =
    values

  // tip configurations settings
  const handleCheckedTipConfigurations = (name) => values[name]

  const handleToggleCustomTipOption = (value, name) => {
    if (name === 'custom_tip_option' && value === true) {
      // when user enables custom tip option, set null to the last element of tip_values (Tip option 5),
      // because then we hide textbox from Tip Option 5, so value has to be set to null
      setFieldValue('tip_values[3]', null)
    }

    setFieldValue(name, value)
  }

  // tip options
  const handleSaveTipOption = (value, index) => {
    const newTipValues = [...tip_values]
    newTipValues[index] = value
    const nonNullTipValues = compact(newTipValues)
    // selected_tip_option relies on the tip_values array, so if the selected_tip_option is
    // selected and user removes the value from the tip_values array, we need to set the selected_tip_option to null
    if (!nonNullTipValues.includes(selected_tip_option)) {
      setFieldValue('selected_tip_option', null)
    }
    setFieldValue(
      `tip_values[${index}]`,
      isEmpty(value) ? null : Number(value)
    )
  }

  // default tip option
  const handleChangeDefaultSelectedTipOption = (value) => {
    // when user unselect the default option, set the selected_tip_option to undefined for validation purposes
    if (!value) return setFieldValue('selected_tip_option', undefined)

    // value is -1 when the default ("None") option is selected
    if (value === -1)
      return setFieldValue('selected_tip_option', null)

    return setFieldValue('selected_tip_option', Number(value))
  }

  return (
    <>
      <Settings
        handleChecked={handleCheckedTipConfigurations}
        handleChange={handleToggleCustomTipOption}
        handleSetName={(name) => name}
        header="Settings"
        classNames="-border-top-none -padding-top-none"
      />
      <TipOptions
        options={tip_values}
        isOther={custom_tip_option}
        handleSaveTipOption={handleSaveTipOption}
        showError={showValidationErrors}
        errorMessage={errors?.tip_values}
        handleSetName={(index) => `tip_values[${index}]`}
        isHeaderBold
      />
      <DefaultTipOption
        tipValues={tip_values}
        selectedTipOption={selected_tip_option}
        handleChangeDefaultSelectedTipOption={
          handleChangeDefaultSelectedTipOption
        }
        error={errors?.selected_tip_option}
        showError={showValidationErrors}
        name="selected_tip_option"
        isHeaderBold
      />
      <RevenueCentersOverrideList />
    </>
  )
}

export default TipConfigurationsBody
